import i18n from './../../../../../shared/i18n';
import BaseModel from "../../../../../core/components/input-widget/BaseModel";
import {getPhoneRuleObj} from "@/plugins/vee-validate";

export default class ItemLocation extends BaseModel {
  name = '';
  is_primary = false;
  is_released = false;
  address = null;
  address_2 = null;
  address_3 = null;
  city = null;
  country_code = null;
  zip_code = null;
  state = null;
  email = null;
  phone = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    name: 'required',
    phone: getPhoneRuleObj(),
    email: 'email|max:73',
  };

  attributeLabels = {
    name: i18n.t('Name'),
    is_primary: i18n.t('Primary Item Location'),
    is_released: i18n.t('Released Location'),
    address: i18n.t('Address 1'),
    address_2: i18n.t('Address 2'),
    address_3: i18n.t('Address 3'),
    city: i18n.t('City'),
    state: i18n.t('State/County'),
    zip_code: i18n.t('Zip/Postcode'),
    country_code: i18n.t('Country'),
    country: i18n.t('Country'),
    email: i18n.t('Email'),
    phone: i18n.t('Phone'),
  };

  attributeHints = {
    is_released: i18n.t('When enabled, this location is automatically assigned to an item once its entire quantity is collected.'),
  };
}
